"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentSortBy = exports.SubTestType = exports.MasterTestSubType = exports.CampaignTypes = exports.CampaignStateValue = exports.MasterTestType = exports.HistoryOrderType = exports.HistoryOrderBy = exports.HistoryType = exports.ActionsHistory = exports.ExperimentFilterState = exports.ExperimentFilterStatus = exports.SEQUENTIAL_TESTING_SETUPS = exports.SEQUENTIAL_TESTING_MODES = exports.StatisticEngine = exports.TargetingEventMode = exports.TestState = void 0;
var TestState;
(function (TestState) {
    TestState["PLAY"] = "play";
    TestState["PAUSE"] = "pause";
})(TestState = exports.TestState || (exports.TestState = {}));
var TargetingEventMode;
(function (TargetingEventMode) {
    TargetingEventMode["FASTEST"] = "fastest";
    TargetingEventMode["DOC_READY"] = "docready";
    TargetingEventMode["WAIT_UNTIL"] = "waituntil";
    TargetingEventMode["NO_AJAX"] = "noajax";
})(TargetingEventMode = exports.TargetingEventMode || (exports.TargetingEventMode = {}));
var StatisticEngine;
(function (StatisticEngine) {
    StatisticEngine["Bayesian"] = "bayesian";
    StatisticEngine["Frequentist"] = "frequentist";
})(StatisticEngine = exports.StatisticEngine || (exports.StatisticEngine = {}));
exports.SEQUENTIAL_TESTING_MODES = {
    EMAIL: 'email',
    INTERRUPT: 'interrupt',
    NONE: null,
};
exports.SEQUENTIAL_TESTING_SETUPS = {
    HIGH: 'high',
    BALANCED: 'balanced',
    LOW: 'low',
    NONE: null,
};
var ExperimentFilterStatus;
(function (ExperimentFilterStatus) {
    ExperimentFilterStatus["Draft"] = "draft";
    ExperimentFilterStatus["ReadyToLaunch"] = "ready_to_launch";
    ExperimentFilterStatus["Play"] = "play";
    ExperimentFilterStatus["Pause"] = "pause";
    ExperimentFilterStatus["Analysis"] = "analysis";
    ExperimentFilterStatus["Ended"] = "ended";
    ExperimentFilterStatus["InQa"] = "in_qa";
    ExperimentFilterStatus["Interrupted"] = "interrupted";
    ExperimentFilterStatus["Scheduled"] = "scheduled";
    ExperimentFilterStatus["Archive"] = "archive";
})(ExperimentFilterStatus = exports.ExperimentFilterStatus || (exports.ExperimentFilterStatus = {}));
var ExperimentFilterState;
(function (ExperimentFilterState) {
    ExperimentFilterState["Draft"] = "draft";
    ExperimentFilterState["ReadyToLaunch"] = "ready_to_launch";
    ExperimentFilterState["Analysis"] = "analysis";
    ExperimentFilterState["Ended"] = "ended";
    ExperimentFilterState["InQa"] = "in_qa";
    /** Campaigns played with or without QA */
    ExperimentFilterState["Play"] = "play";
    /** Campaigns paused with or without QA */
    ExperimentFilterState["Pause"] = "pause";
    ExperimentFilterState["PlayWithQA"] = "play_qa";
    ExperimentFilterState["PauseWithQA"] = "pause_qa";
    ExperimentFilterState["PlayWithoutQA"] = "play_no_qa";
    ExperimentFilterState["PauseWithoutQA"] = "pause_no_qa";
    ExperimentFilterState["Scheduled"] = "scheduled";
    ExperimentFilterState["Unscheduled"] = "unscheduled";
    ExperimentFilterState["Archive"] = "archive";
    ExperimentFilterState["Unarchive"] = "unarchive";
    ExperimentFilterState["PlayAndScheduled"] = "play_scheduled";
    ExperimentFilterState["Interrupted"] = "interrupted";
    ExperimentFilterState["NeverPlayed"] = "never_played";
    ExperimentFilterState["Played"] = "played";
})(ExperimentFilterState = exports.ExperimentFilterState || (exports.ExperimentFilterState = {}));
var ActionsHistory;
(function (ActionsHistory) {
    ActionsHistory["CREATE"] = "create";
    ActionsHistory["PLAY"] = "play";
    ActionsHistory["STATUS_PLAY"] = "status.play";
    ActionsHistory["PAUSE"] = "pause";
    ActionsHistory["STATUS_PAUSE"] = "status.pause";
    ActionsHistory["DRAFT"] = "status.draft";
    ActionsHistory["READY_TO_LAUNCH"] = "status.ready_to_launch";
    ActionsHistory["ANALYSIS"] = "status.analysis";
    ActionsHistory["ENDED"] = "status.ended";
    ActionsHistory["IN_QA"] = "status.in_qa";
    ActionsHistory["INTERRUPTED"] = "status.interrupted";
    ActionsHistory["RESET"] = "reset";
    ActionsHistory["ARCHIVE"] = "archive";
    ActionsHistory["STATUS_ARCHIVE"] = "status.archive";
    ActionsHistory["UNARCHIVE"] = "unarchive";
    ActionsHistory["ALLOCATION_UPDATE"] = "allocation.update";
    ActionsHistory["VARIATION_CREATE"] = "variation.create";
    ActionsHistory["VARIATION_DELETE"] = "variation.delete";
    ActionsHistory["SCHEDULE_SETUP_PLAY"] = "schedule.setup.play";
    ActionsHistory["SCHEDULE_SETUP_PAUSE"] = "schedule.setup.pause";
    ActionsHistory["NAME_UPDATE"] = "name.update";
    ActionsHistory["PLAY_SCHEDULED"] = "play.scheduled";
    ActionsHistory["PAUSE_SCHEDULED"] = "pause.scheduled";
    ActionsHistory["QA_MODE_ON_FIRST_TIME"] = "qa.first";
    ActionsHistory["QA_MODE_ON"] = "qa.on";
    ActionsHistory["QA_MODE_OFF"] = "qa.off";
})(ActionsHistory = exports.ActionsHistory || (exports.ActionsHistory = {}));
var HistoryType;
(function (HistoryType) {
    HistoryType["ACTION"] = "action";
    HistoryType["EDITION"] = "edition";
    HistoryType["WARNING"] = "warning";
})(HistoryType = exports.HistoryType || (exports.HistoryType = {}));
var HistoryOrderBy;
(function (HistoryOrderBy) {
    HistoryOrderBy["ASC"] = "ASC";
    HistoryOrderBy["DESC"] = "DESC";
})(HistoryOrderBy = exports.HistoryOrderBy || (exports.HistoryOrderBy = {}));
var HistoryOrderType;
(function (HistoryOrderType) {
    HistoryOrderType["ID"] = "id";
    HistoryOrderType["ACTION"] = "action";
})(HistoryOrderType = exports.HistoryOrderType || (exports.HistoryOrderType = {}));
/**
 * @deprecated use CampaignTypes instead (doc in progress)
 */
var MasterTestType;
(function (MasterTestType) {
    MasterTestType["AA"] = "aa";
    MasterTestType["AB"] = "ab";
    MasterTestType["PREDICTIVE"] = "predictive";
    MasterTestType["MULTIPAGE"] = "multipage";
    MasterTestType["MULTIVARIATE"] = "multivariate";
    MasterTestType["MASTERSEGMENT"] = "mastersegment";
})(MasterTestType = exports.MasterTestType || (exports.MasterTestType = {}));
var CampaignStateValue;
(function (CampaignStateValue) {
    CampaignStateValue[CampaignStateValue["Create"] = 0] = "Create";
    CampaignStateValue[CampaignStateValue["Play"] = 1] = "Play";
    CampaignStateValue[CampaignStateValue["Pause"] = 2] = "Pause";
})(CampaignStateValue = exports.CampaignStateValue || (exports.CampaignStateValue = {}));
/**
 * - CampaignTypes provides a flattened list of unique types we deal with throughout the codebase
 */
var CampaignTypes;
(function (CampaignTypes) {
    CampaignTypes["AA"] = "aa";
    CampaignTypes["AB"] = "ab";
    CampaignTypes["PREDICTIVE"] = "predictive";
    CampaignTypes["PATCH"] = "patch";
    CampaignTypes["MULTIPAGE"] = "multipage";
    CampaignTypes["MULTIPAGE_PATCH"] = "mtpp";
    CampaignTypes["MULTIVARIATE"] = "multivariate";
    CampaignTypes["SIMPLE_PERSO"] = "sp";
    CampaignTypes["MULTIPAGE_PERSO"] = "mpp";
    CampaignTypes["MULTIEXPERIENCE_PERSO"] = "mep";
})(CampaignTypes = exports.CampaignTypes || (exports.CampaignTypes = {}));
/**
 * MASTERSEGMENT tests have next sub types:
 *   - SIMPLE_PERSO;
 *   - MULTIPAGE_PERSO;
 *   - MULTIEXPERIENCE_PERSO.
 *
 * For the rest tests the sub type equal to the type.
 *   It means that:
 *     - AB tests have type "ab" and sub type "ab";
 *     - MULTIPAGE tests have type "multipage" and sub type "multipage".
 *
 * @deprecated use CampaignTypes instead (doc in progress)
 */
var MasterTestSubType;
(function (MasterTestSubType) {
    MasterTestSubType["AA"] = "aa";
    MasterTestSubType["AB"] = "ab";
    MasterTestSubType["PREDICTIVE"] = "predictive";
    MasterTestSubType["PATCH"] = "patch";
    MasterTestSubType["MULTIPAGE"] = "multipage";
    MasterTestSubType["MULTIVARIATE"] = "multivariate";
    MasterTestSubType["SIMPLE_PERSO"] = "sp";
    MasterTestSubType["MULTIPAGE_PERSO"] = "mpp";
    MasterTestSubType["MULTIEXPERIENCE_PERSO"] = "mep";
})(MasterTestSubType = exports.MasterTestSubType || (exports.MasterTestSubType = {}));
var SubTestType;
(function (SubTestType) {
    SubTestType["AB"] = "ab";
    SubTestType["SUBSEGMENT"] = "subsegment";
    SubTestType["PREDICTIVE"] = "predictive";
})(SubTestType = exports.SubTestType || (exports.SubTestType = {}));
var ExperimentSortBy;
(function (ExperimentSortBy) {
    ExperimentSortBy["ID"] = "id";
    ExperimentSortBy["NAME"] = "name";
    ExperimentSortBy["STATUS"] = "status";
    ExperimentSortBy["LAST_PAUSE_DATE"] = "last_pause_date";
    ExperimentSortBy["LAST_PLAY_DATE"] = "last_play_date";
})(ExperimentSortBy = exports.ExperimentSortBy || (exports.ExperimentSortBy = {}));
//# sourceMappingURL=types.js.map